const { useEffect, useState } = wp.element;

const Component = ({ bookingData, department, setDepartment }) => {
    const [openDepartmentSelect, setOpenDepartmentSelect] = useState(false);

    return (
        <div className="section" id="section-department">
            <div className="container grid">
                <h1 className="section-title">Hvor vil du bestille time?</h1>

                <div className={`department-select ${openDepartmentSelect ? 'open' : ''}`}>
                    <button className="department-select-toggle" onClick={() => { setOpenDepartmentSelect(!openDepartmentSelect) }}>
                        <span>{department?.name || 'Velg salong'}</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_716_5854" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_716_5854)">
                                <path d="M12 15.3751L6 9.3751L7.4 7.9751L12 12.5751L16.6 7.9751L18 9.3751L12 15.3751Z" fill="#1E1E1E"/>
                            </g>
                        </svg>
                    </button>
                    <div className="department-select-list">
                        {
                            bookingData?.departments?.map((department, key) => {
                                return (
                                    <button onClick={() => { setDepartment(department); setOpenDepartmentSelect(false) }} key={key}>
                                        {department.name}
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>

                {
                    false &&
                    <div className="department-select-text">
                        <ul>
                            <li>
                                Kontakt Bogstadveien på telefon <strong>900 93 402</strong> hvis du har noen spørsmål.
                            </li>
                            <li>
                                For balayage eller andre avanserte fargebehandlinger anbefaler vi at du kontakter salongen sånn at vi best kan sette av nok tid.
                            </li>
                        </ul>
                    </div>
                }
            </div>
            
            {
                department &&
                <svg className="progress-arrow" width="64" height="32" viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0H64L32 32L0 0Z" fill="currentColor"/>
                </svg>
            }
        </div>
    )
}

export default Component;